module.exports = __webpack_public_path__ + "static/media/gochi_price.3b93e1a8.jpg";